
export const ISSUE_ROUTES = [
  {
    path: "issueDetailsForm",
    name: "issueDetailsForm",
    component: () =>
        import(/* webpackChunkName: "issues" */ "@/modules/issues/components/forms/IssuesDetailsForm")
  },
  {
    path: "issueOverview",
    name: "issueOverview",
    component: () =>
        import(/* webpackChunkName: "issues" */ "@/modules/issues/components/overview/IssueOverview")
  }
];
